import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import { CertificateStatus } from 'hmi';
import { getIconColour } from '../../../../helpers/app';
import CrmSection from './CrmSection';
import StarIcon from '../../../../assets/icons/Star';
import { ratingState } from './helper';
import { getRatingScore } from '../../../../services/DexService';
import { ApplicationInterface } from '../../../../interfaces/application';

type PropsType = {
  application: ApplicationInterface;
};

const useStyles = makeStyles(() => ({
  container: {
    display: 'grid',
    gridRowGap: '47px',
  },
  certificate: {
    display: 'flex',
    justifyContent: 'left',
    '& .certificate-status': {
      minHeight: 'auto',
      padding: 0,
      marginTop: 0,

      '& .certificate-status-rating-bottom-wrapper': {
        marginTop: '-3.6rem',
      },
    },
  },
}));

const CrmRating: React.FC<PropsType> = ({ application }) => {
  const [score, setScore] = useState(0);
  const type = ratingState(application);
  const classes = useStyles();
  const theme = useTheme();

  const getScore = async (rating: string) => {
    try {
      const res = await getRatingScore(rating);

      if (res?.parsedBody) {
        setScore(res.parsedBody.score);
      }
    } catch (e) {
      // TODO Add error handling
    }
  };

  useEffect(() => {
    getScore(application.rating?.rating || '');
  }, [application.rating?.rating]);

  return (
    <CrmSection
      icon={<StarIcon stroke={getIconColour(type, theme)} />}
      title="Rating"
      description="Self-reported data exchange ratings."
      type={type}
    >
      <div className={classes.container}>
        <Typography>
          This rating system* provides all assurance that data transactions are transparent. Please
          note that the rating you provide is required to ensure your declaration is true legally,
          technically and commercially. These criteria will determine the scoring of the
          application. It is important that these are read and understood and observed.
        </Typography>
        <div className={classes.certificate}>
          <CertificateStatus
            score={application.rating?.rating || ''}
            points={score}
            text="Certified"
          />
        </div>
      </div>
    </CrmSection>
  );
};

export default CrmRating;
